export const DT_FORMATS = {
  date: "DD-MMM-YYYY",
  dateTime: "DD-MMM-YYYY HH:mm",
};

export const PAGE_SIZE = 20;

// Mirrors maxAttachmentBytes in attachments.go — the server rejects anything larger,
// so the spreadsheet importer refuses it up front rather than after a long upload.
export const MAX_ATTACHMENT_BYTES = 25 * 1024 * 1024;

export const STATUS_COLORS: Record<string, string> = {
  DRAFT: "default",
  PENDING_APPROVAL: "gold",
  APPROVED: "blue",
  ALLOCATION_REQUIRED: "gold",
  PARTIALLY_ALLOCATED: "cyan",
  FULLY_ALLOCATED: "blue",
  PARTIALLY_ISSUED: "cyan",
  PARTIALLY_DISPATCHED: "cyan",
  FULLY_DISPATCHED: "blue",
  ISSUED: "green",
  FULFILLED: "green",
  IN_TRANSIT: "cyan",
  COMPLETED: "green",
  ORDERED: "cyan",
  PARTIALLY_RECEIVED: "cyan",
  RECEIVED: "green",
  ALLOCATED: "blue",
  DISPATCHED: "cyan",
  SUPERSEDED: "default",
  POSTED: "green",
  REVERSED: "orange",
  REJECTED: "red",
  CANCELLED: "default",
  ACTIVE: "green",
  ON_HOLD: "gold",
  CLOSED: "default",

  // Attendance (spec §28, Phase 8)
  SUBMITTED: "gold",
  RETURNED_FOR_CORRECTION: "orange",
  HR_APPROVED: "blue",
  LOCKED: "green",
  REOPENED: "orange",
  PRESENT: "green",
  ABSENT: "red",
  LEAVE: "gold",
  NOT_SCHEDULED: "default",

  // Service Requests (spec §29, Phase 9)
  ASSIGNED: "cyan",
  IN_PROGRESS: "blue",
};

export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID ?? "";
export const MS_CLIENT_ID = import.meta.env.VITE_MS_CLIENT_ID ?? "";
export const MS_TENANT_ID = import.meta.env.VITE_MS_TENANT_ID ?? "common";

// Free-form name of the deployment this build targets ("development", "staging", …).
// Empty or "production" means no environment banner (see EnvironmentBanner).
export const ENVIRONMENT = (import.meta.env.VITE_ENVIRONMENT ?? "").trim();
